import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import apiProfile from '@api/apiProfile';
import notificationService from '@utils/notificationService';

const { TextArea } = Input;

export default function FeatureRequestModal({ open, onChange, titleVariant, bug }) {
  const [text, setText] = useState('');
  const { t } = useTranslation();
  const modalTitle = t(
    titleVariant === 'taskInterest'
      ? 'title.Tell More About Your Tasks'
      : titleVariant === 'integrationNeeds'
        ? 'title.Tell Us More About Your Integration Needs'
        : 'title.reportProblem'
  );

  async function onSend() {
    onClose();

    try {
      const { data } = await apiProfile.featureRequest(window.location.href + ' - ' + text, bug);
      notificationService.success({ message: data });
    } catch (error) {
      notificationService.error({ message: error.message });
    }
    setText('');
  }

  function onClose() {
    onChange(false);
  }

  return (
    <Modal
      okText={t('action.send')}
      cancelText={t('action.cancel')}
      title={modalTitle}
      open={open}
      onOk={onSend}
      onCancel={onClose}
    >
      <TextArea
        autoFocus
        rows={4}
        maxLength={1000}
        placeholder={t('description.reportProblem')}
        value={text}
        onChange={({ target }) => setText(target.value)}
      />
    </Modal>
  );
}

FeatureRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  titleVariant: PropTypes.oneOf(['reportProblem', 'taskInterest', 'integrationNeeds']),
  bug: PropTypes.bool,
};
